// Third party imports
import React from "react";
import classnames from "classnames";

// Styles and constants
import useStyles from "../../Subscriptions/components/TableFields/TableFields.styles";
import {
  HEADER_NOTE,
  REFUND_STATUS,
  REFUND_STATUS_ENUM,
} from "../refund.constant";
import { useNotifications } from "utils/hooks";
import { useRefresh } from "react-admin";
import { Tooltip, IconButton } from "@my-scoot/component-library-legacy";
import { Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { useRetryRefund } from "../utils/hooks/useRetryRefund";

export const StatusField = ({ record = {}, source }) => {
  const classes = useStyles();
  const { notify } = useNotifications();
  const refresh = useRefresh();
  const { anchorEl, handleMenuClick, handleMenuClose, handleRetryOnClick } =
    useRetryRefund({
      record,
      refresh,
      notify,
    });
  const { title, variant, icon } =
    REFUND_STATUS[REFUND_STATUS_ENUM[record[source]]] ?? {};

  const isFailed = REFUND_STATUS.FAILED.id === record[source];
  const statusChip = (
    <div className="tw-flex tw-items-center">
      <span
        className={classnames(
          classes.status,
          variant && classes[`status__${variant}`]
        )}
      >
        {icon}
        {title}
      </span>

      {isFailed && (
        <>
          <IconButton
            size="small"
            onClick={handleMenuClick}
            className="tw-ml-2"
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleRetryOnClick}>Retry</MenuItem>
          </Menu>
        </>
      )}
    </div>
  );

  const checkStatusType = [
    REFUND_STATUS.PENDING.id,
    REFUND_STATUS.EXECUTED.id,
  ].includes(record[source]);

  if (checkStatusType) {
    return (
      <Tooltip title={HEADER_NOTE.refund_status} color="primary" arrow>
        {statusChip}
      </Tooltip>
    );
  }

  return statusChip;
};
